const craftsmenAltTextI18nDe = {
    'altTextTeamsImage': 'Repair Rebels Handwerkernetzwerk - Team Kollaboration',
    'altTextExpertiseImage': 'Repair Rebels Expertise nachhaltiger Modereparatur Service',
    'altTextDecorateImage': 'Digitale Plattform für die besten Handwerksbetriebe in Deutschland und Österreich',
  };
  
export default craftsmenAltTextI18nDe;